import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class NotEqualIcon extends BaseIcon {
  getChildren = () => [
    <polygon fill={ this.getColor() } points="10.47 7 13 7 13 6 11.14 6 10.47 7"/>,
    <polygon fill={ this.getColor() } points="7.53 6 3 6 3 7 6.86 7 7.53 6"/>,
    <rect fill={ this.getColor() } x="0.79" y="7.5" width="14.42" height="1" transform="translate(-3.09 10.22) rotate(-56.31)"/>,
    <polygon fill={ this.getColor() } points="5.53 9 3 9 3 10 4.86 10 5.53 9"/>,
    <polygon fill={ this.getColor() } points="8.47 10 13 10 13 9 9.14 9 8.47 10"/>
    ]
  getViewBox = () => '0 0 16 16'
}
